<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="changeTab">
            <el-tab-pane v-for="item in data" :name="item.name" :key="item.name">
                <span slot="label" v-if="item.showBadge">
                    <el-badge style="margin-top: 10px;margin-bottom: 10px"
                        :value="pageTotal[item.name] === 0 ? '' : pageTotal[item.name]" :max="99">{{ item.label }}</el-badge>
                </span>
                <span slot="label" v-else>{{ item.label }}</span>
            </el-tab-pane>
        </el-tabs>
        <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
            <div style="display: flex; align-items: center; flex-grow: 1;">
                <router-view></router-view>
                <el-button size="small"
                    v-if="!['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(role) && activeName === 'TO_BE_CLAIMED'"
                    type="success" icon="el-icon-plus" @click="handleAdd()">添加
                </el-button>
                <el-button size="small"
                    v-if="!['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(role) && ['PENDING_REFUND', 'ALL'].includes(activeName)"
                    type="danger" @click="refund('',true)">批量退款
                </el-button>
                <el-button size="small"
                    v-if="!['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(role) && ['PENDING_REFUND', 'ALL'].includes(activeName)"
                    type="primary" @click="refund('',false)">批量取消退款
                </el-button>
            </div>
        </div>

        <w-table ref="wMyTable" :columns="checkedCol" :table-data="tableData" :page="page" :isShowRowSelection="true"
            @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" @rowSelection="rowSelection($event)"
            @pageChange="handlePagePagination">
            <template slot="otherCon">
                <table-col :cols="columns" :columnType="activeName + 'TableCol'" :table-col="columns"
                    @submit="getCheckedBox"></table-col>
            </template>
            <template slot="operation" slot-scope="{record}">
                <el-button size="mini" type="warning"
                    v-if="['TO_BE_CLAIMED'].includes(record.advancePaymentStatus) && ['ADMIN', 'FINANCE', 'CASHIER'].includes(role)"
                    @click="handleEdit(record)">编辑</el-button>
                <el-button size="mini"
                    v-if="!['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(role) && ['PENDING_REFUND'].includes(record.advancePaymentStatus)"
                    type="danger" @click="refund(record,true)">退款</el-button>
                <el-button size="mini"
                    v-if="!['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(role) && ['PENDING_REFUND'].includes(record.advancePaymentStatus)"
                    type="primary" @click="refund(record,false)">取消退款</el-button>
            </template>
            <template slot="advancePaymentStatus" slot-scope="{text,record}">
                <div style="display: flex;align-items: center;justify-content: center;">
                    <el-tag :type="getAdvanceColor(text, 'tagType')"
                        :style="{ color: getAdvanceColor(text, 'color'), 'background-color': getAdvanceColor(text, 'backgroundColor') }">
                        {{ getAdvanceColor(text, 'name') }}</el-tag>
                </div>
            </template>
            <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column, clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 10px 15px">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='待认领'>待认领</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已退款'>已退款</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已垫付'>已垫付</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='待退款'>待退款</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='取消退款'>取消退款</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </template>
            <template slot="status" slot-scope="{text,record}">
                <span style="display: flex;align-items: center">
                    <el-tag :type="getStatusColor(text, 'tagType')"
                        :style="{ color: getStatusColor(text, 'color'), 'background-color': getStatusColor(text, 'backgroundColor') }">
                        {{ getStatusColor(text, 'name') }}</el-tag>
                    <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
                        :text="record['rejectionReason']" :column="{ title: '驳回原因' }" :onlyDetail="true"
                        :isOpenHtml="false">
                    </w-ellipsis-and-look>
                </span>
            </template>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <add-edit-advance v-if="addEdit.showDialog" :show-dialog="addEdit.showDialog" :type="addEdit.type"
            :select-detail="addEdit.selectDetail" @submit="closeAddEditDialog">
        </add-edit-advance>
    </div>
</template>


<script>

import { deleteAdvanceRecord, getAdvancePage, refundAdvance } from "@/api/dilivery/advance";
import PictureLoading from "@/components/customerTable/PictureLoading";
import { tableOperationMixin } from "@/mixins/tableOperation";
import TableCol from "@/components/customerTable/TableCol.vue";
import { advance } from "@/utils/data/tableCol/info/advance/advance";
import AddEditAdvance from "@/components/info/advance/AddEditAdvance.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { getAdvanceColor, getStatusColor } from "@/color";
const baseURL = process.env.VUE_APP_BASE_API

export default {
    name: "AdvanceInfo",
    components: {
        PictureLoading, TableCol, AddEditAdvance
    },
    mixins: [tableOperationMixin],
    data() {
        return {
            tableData: [],
            selectable: [],
            searchConditionTag: [],
            sortConditionTag: [],
            page: {
                currentNum: 1,
                pageSize: 10,
                total: 0
            },
            data: [
                { label: '全部', name: 'ALL', showBadge: false },
                { label: '已垫付', name: 'PAID', showBadge: false },
                { label: '待退款', name: 'PENDING_REFUND', showBadge: true },
                { label: '已退款', name: 'REFUNDED', showBadge: false },
                { label: '取消退款', name: 'REFUND_CANCELLED', showBadge: false },
            ],
            sendData: {
                ALL: {},
                PAID: { 'query#advancePaymentStatus.IN': 'PAID' },
                PENDING_REFUND: { 'query#advancePaymentStatus.IN': 'PENDING_REFUND' },
                REFUNDED: { 'query#advancePaymentStatus.IN': 'REFUNDED' },
                REFUND_CANCELLED: { 'query#advancePaymentStatus.IN': 'REFUND_CANCELLED' },
            },
            pageTotal: { ALL: 0, PAID: 0, PENDING_REFUND: 0, REFUNDED: 0, REFUND_CANCELLED: 0 },
            checkedCol: [],
            loading: true,
            activeName: 'PENDING_REFUND',
            batch: {
                showDialog: false,
                type: '',
                selectDetail: []
            },
            addEdit: {
                showDialog: false,
                type: '',
                selectDetail: {}
            },
            receivingUnit: [
                { id: "10", name: "南京微合生物科技有限公司" },
                { id: "9", name: "成都百麦斯特生物科技有限公司" },
                { id: "8", name: "江苏凌帆生物科技有限公司" },
                { id: "7", name: "北京凌恩生物科技有限公司" },
                { id: "6", name: "上海盈飞生物科技有限公司" },
                { id: "5", name: "陕西智享凌波微课生物科技有限公司" },
                { id: "4", name: "江苏普朗睿恩生物科技有限公司" },
                { id: "3", name: "南京凌恩生物科技有限公司" },
                { id: "2", name: "杭州普朗爱锐生物科技有限公司" },
                { id: "1", name: "上海凌恩生物科技有限公司" }
            ]
        }
    },
    computed: {
        columns() {
            return JSON.parse(JSON.stringify(advance(this.searchConditionTag || {}, this.activeName)))
        },
        role() {
            return getDataInLocalStorage('role')
        }
    },
    mounted() {
        this.loadAllTabTotals()
        this.getData()
    },
    methods: {
        getAdvanceColor,
        getStatusColor,
        async download(row) {
            try {
                let url = `${baseURL}/audit-info/attachment/${row.id}/CLAIM_THE_ADVANCE_PAYMENT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        loadAllTabTotals() {
            Object.keys(this.sendData).forEach(tabName => {
                let sendData = { ...this.sendData[tabName] }
                if (tabName === 'TO_BE_CLAIMED' && ['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(this.role)) {
                    sendData['claimFlag'] = true
                }
                getAdvancePage({ 'page.current': 1, 'page.size': 1 }, sendData, 'ADVANCE_PAYMENT_CLAIM_AUDIT').then(res => {
                    if (res.code === 200) {
                        this.$set(this.pageTotal, tabName, parseInt(res.data.total))
                    }
                })
            })
        },
        claim(row) {
            this.addEdit.showDialog = true
            this.addEdit.type = 'claim'
            this.addEdit.selectDetail = { ...row }
        },
        handleEdit(row) {
            if (row) {
                this.addEdit.showDialog = true
                this.addEdit.type = 'edit'
                this.addEdit.selectDetail = { ...row }
            } else {
                if (this.selectable.length === 0) {
                    this.$messageUi.error('请选择至少一条数据')
                    return
                }
                this.batch.showDialog = true
                this.batch.type = 'edit'
                this.batch.selectDetail = [...this.selectable]
            }
        },
        handleAdd() {
            this.batch.showDialog = true
            this.batch.type = 'add'
            this.batch.selectDetail = []
        },
        closeBatchAddDialog() {
            this.batch.showDialog = false
            this.batch.type = ''
            this.batch.selectDetail = []
            this.getData(true)
        },
        closeAddEditDialog() {
            this.addEdit.showDialog = false
            this.addEdit.type = ''
            this.addEdit.selectDetail = {}
            this.getData(true)
        },
        getCheckedBox(col, cols) {
            this.checkedCol = col.filter(item => cols.includes(item.title))
        },
        changeTab() {
            this.$nextTick(() => {
                this.tableData = []
                this.selectable = []
                this.searchConditionTag = []
                this.sortConditionTag = []
                this.page = { currentNum: 1, pageSize: 10, total: 0 }
                if (this.$refs.wMyTable) {
                    this.$refs.wMyTable.selectedRowKeys = []
                    this.$refs.wMyTable.searchConditionTag = []
                }
                this.getData()
            })
        },
        rowSelection(selectedRows) {
            this.selectable = JSON.parse(JSON.stringify(selectedRows))
        },
        getData(searchFlag) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
            }
            if (searchFlag) {
                params = { 'page.current': 1, 'page.size': 10 }
            }
            if (this.sortConditionTag && this.sortConditionTag.length > 0) {
                params["order"] = this.sortConditionTag.map(sortCondition => {
                    return sortCondition.colName + "." + sortCondition.order;
                }).join(",");
            }
            let sendData = { ...this.sendData[this.activeName] }
            if (this.activeName === 'TO_BE_CLAIMED' && ['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER'].includes(this.role)) {
                sendData['claimFlag'] = true
            }
            if (this.searchConditionTag && this.searchConditionTag.length) {
                sendData = this.getSearch(sendData)
            }
            getAdvancePage(params, sendData, 'ADVANCE_PAYMENT_CLAIM_AUDIT').then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records
                    this.page.currentNum = parseInt(res.data.current)
                    this.page.pageSize = parseInt(res.data.size)
                    this.page.total = parseInt(res.data.total)
                    this.$set(this.pageTotal, this.activeName, parseInt(res.data.total))
                }
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        getSearch(sendData) {
            this.searchConditionTag.forEach(item => {
                let value = item.value
                if (item.key === 'advancePaymentStatus') {
                    if (item.value === '待认领') {
                        value = 'TO_BE_CLAIMED'
                    } else if (item.value === '已垫付') {
                        value = 'PAID'
                    } else if (item.value === '待退款') {
                        value = 'PENDING_REFUND'
                    } else if (item.value === '已退款') {
                        value = 'REFUNDED'
                    } else if (item.value === '取消退款') {
                        value = 'REFUND_CANCELLED'
                    }
                } else if (item.key === 'status') {
                    if (item.value === '待审核') {
                        value = 'APPLYING'
                    } else if (item.value === '已通过') {
                        value = 'SUCCESS'
                    } else {
                        value = 'DEFEAT'
                    }
                } else if (item.key === 'contractNumber') {
                    value = value.replace(/[A-Za-z]/g, "")
                }
                if (['contractNumber', 'receivingUnit', 'saleName'].includes(item.key)) {
                    sendData[item.key] = value
                } else {
                    sendData["query#" + item.key + ".LIKE"] = value
                }
            })
            return sendData
        },
        getTableSearchSortCon(ConditionTag) {
            this.searchConditionTag = ConditionTag[0]
            this.sortConditionTag = ConditionTag[1]
            this.getData('search')
        },
        handlePagePagination(page) {
            this.page.currentNum = page.currentNum
            this.page.pageSize = page.pageSize
            this.getData()
        },
        refund(row, flag) {
            let ids = this.selectable.filter(item => ['PENDING_REFUND'].includes(item.advancePaymentStatus)).map(item => item.id)
            if (row && row.id) {
                ids = [row.id]
            } else {
                if (ids.length <= 0) {
                    if (flag) {
                        this.$messageUi.error('请勾选需要批量退款的垫付款')
                    } else {
                        this.$messageUi.error('请勾选需要批量取消退款的垫付款')
                    }
                    return
                }
            }
            const message = flag ? '确定要退款吗?' : '确定要取消退款吗?'
            const message2 = flag ? '请输入退款备注' : '请输入取消退款原因'
            this.$prompt(message2, message, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                let data = {
                    ids,
                    cancel: !flag,
                    remark: value || ''
                }
                refundAdvance(data).then(res => {
                    if (res.code === 200) {
                        this.$store.commit('right/setChangeRed', true)
                        this.$messageUi({
                            type: 'success',
                            message: !flag ? '取消退款成功!' : '退款成功!'
                        })
                        this.selectable = []
                        this.getData(true)
                    }
                }).catch(err => {
                })
            }).catch(() => {
            })
        },
        batchDelete(row) {
            let ids = this.selectable.filter(item => !['DELETED'].includes(item.advancePaymentStatus)).map(item => item.id)
            if (row && row.id) {
                ids = [row.id]
            } else {
                if (ids.length <= 0) {
                    this.$messageUi.error('请勾选需要批量删除的垫付款信息')
                    return
                }
            }
            this.$confirmUi('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    "ids": ids.join(',')
                }
                deleteAdvanceRecord(params).then(res => {
                    if (res.code === 200) {
                        this.$store.commit('right/setChangeRed', true)
                        this.$messageUi({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.selectable = []
                        this.getData(true)
                    }
                }).catch(err => {
                })
            }).catch(() => { })
        },
    }
}
</script>

<style scoped>
h3 {
    margin-top: 0;
    font-size: 25px;
}

h4 {
    font-size: 16px;
}

.fa-spin,
.fa-spin-custom {
    animation: fa-spin 1s infinite linear !important;
}

@keyframes fa-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(359deg);
    }
}

.el-card ul li {
    margin-top: 5px;
    font-weight: 550;
    font-size: 14px;
    word-wrap: break-word;
}
</style>
